import { writable } from "svelte/store";
import type { ImportSummary } from "$lib/models/MasterdataDiff";

export type DiffState = "Idle" | "Loading" | "Ready" | "Applied";

export const diffState = writable<DiffState>("Idle");
export const diffSummary = writable<ImportSummary | null>(null);
